(function() {
  var Storage,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Storage = require('resources/assets/coffee/Core/Storage').Storage;

  exports.OverlayStorage = (function(superClass) {
    extend(OverlayStorage, superClass);

    function OverlayStorage() {
      OverlayStorage.__super__.constructor.call(this);
      this.feature_group = new L.FeatureGroup();
    }

    OverlayStorage.prototype["delete"] = function(k) {
      var v;
      v = this.retrieve(k);
      if (v != null) {
        this.key_count = this.key_count - 1;
        if (v instanceof OverlayStorage) {
          v = v.feature_group;
        }
        this.feature_group.removeLayer(v);
        App.map.removeLayer(v);
        return delete this.data[k];
      }
    };

    OverlayStorage.prototype.store = function(k, v) {
      OverlayStorage.__super__.store.call(this, k, v);
      if (v instanceof OverlayStorage) {
        return this.feature_group.addLayer(v.feature_group);
      } else {
        this.feature_group.addLayer(v);
        return v.addTo(App.map);
      }
    };

    OverlayStorage.prototype.getBounds = function() {
      if (this.count() > 0) {
        return this.feature_group.getBounds();
      } else {
        return App.map.getBounds();
      }
    };

    OverlayStorage.prototype.loadField = function(fields_id, displayOpts, fitBounds) {
      var def_style, style;
      if (displayOpts == null) {
        displayOpts = {};
      }
      if (fitBounds == null) {
        fitBounds = true;
      }
      def_style = {
        fillColor: '#00FF00',
        color: '#00FF00',
        opacity: 0.75,
        weight: 2,
        fillOpacity: 0.2
      };
      style = $.extend(def_style, displayOpts);
      return $.post('backend/grower/fields/get-boundary', {
        id: fields_id
      }, (function(_this) {
        return function(result) {
          var fg, gj, ref, ref1;
          gj = L.geoJson((ref = result.data) != null ? ref.boundary : void 0, {
            style: function() {
              return style;
            }
          });
          fg = new L.FeatureGroup();
          L.GeoUtil.unnestAdd(fg, gj);
          _this.store(fields_id, fg);
          if (fitBounds) {
            switch ((ref1 = result.data) != null ? ref1.locale : void 0) {
              case 'en_CA':
                App.map.fitBounds(_this.getBounds(), {
                  maxZoom: 16
                });
                break;
              case 'en_ZA':
                App.map.fitBounds(_this.getBounds(), {
                  maxZoom: 17
                });
                break;
              default:
                App.map.fitBounds(_this.getBounds());
            }
          }
          return fg.addTo(App.map);
        };
      })(this));
    };

    return OverlayStorage;

  })(Storage);

}).call(this);
